module.exports = __webpack_public_path__ + "img/eyes2.14c04816.svg";